


















































































































import BaseComponent from '@/components/base-component.vue';
import DeliveryAddressHistButton from '@/components/delivery-address/delivery-address-hist-button.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { BloqueioDesbloqueioParmDTO, EnderecoEntregaFiltroParmDTO } from '@/interfaces/delivery-address';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { PaginationSyncDTO } from '../../../interfaces/base-dto';
import * as service from '../../../services/delivery-address';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    DeliveryAddressHistButton,
    UiAutocomplePatients,
    UiAutoCompleteAddress
  }
})
export default class DeliveryAddress extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filtros = new EnderecoEntregaFiltroParmDTO();
  public endereco = null;
  public id: Number = null;
  public descOld = null;

  public headers: any = [
    { text: 'Unidade', value: 'nomeUnidade', sortable: true },
    { text: 'Descrição', value: 'descricao', sortable: true },
    { text: 'Endereço', value: 'enderecoExtenso', sortable: true },
    { text: 'Pacientes', value: 'qtdePacientes', sortable: true, align: 'center' },
    { text: 'Status', value: 'bloqueado', sortable: true, align: 'center' },
    { text: 'Último uso', value: 'dataUltimoUso', sortable: true, align: 'center' },
    { text: 'Dias sem Uso', value: 'diasSemUso', sortable: true, align: 'center' },
    { text: '', value: 'actions', align: 'right', sortable: false }
  ];

  private itensDiasSemUso = [
    { id: 7, label: '7 dias ou mais' },
    { id: 15, label: '15 dias ou mais' },
    { id: 30, label: '30 dias ou mais' },
    { id: 60, label: '60 dias ou mais' },
    { id: 90, label: '90 dias ou mais' },
    { id: 180, label: '6 meses ou mais' },
    { id: 365, label: '1 ano ou mais' },
    { id: 730, label: '2 anos ou mais' },
    { id: 1095, label: '3 anos ou mais' }
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public items: any[] = [];
  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  private mounted(): void {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.items = [];
          this.loading = true;
          this.error = false;
        }),
        switchMap((filter) => {
          return service.findDeliveryAddress(filter);
        })
      )
      .subscribe(
        (res) => {
          this.items = res.content;
          PaginationSyncDTO.update(this.pagination, res);
          this.loading = false;
          this.error = false;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        }
      );

    this.pesquisar();
  }

  private onChangeSearch() {
    this.pagination.page = 1;
    this.pesquisar();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePage() {
    this.pesquisar();
  }

  pesquisar() {
    this.descOld = this.filtros.descricao;
    this.filtros.update(this.pagination);
    if (this.endereco) {
      this.filtros.logradouro = this.endereco.logradouro;
      this.filtros.numero = this.endereco.numero;
      this.filtros.bairro = this.endereco.bairro;
      this.filtros.municipio = this.endereco.municipio;
      this.filtros.estado = this.endereco.estado;
    } else {
      this.filtros.logradouro = null;
      this.filtros.numero = null;
      this.filtros.bairro = null;
      this.filtros.municipio = null;
      this.filtros.estado = null;
    }
    this.execBehaviorSub$.next(this.filtros);
  }

  block(item) {
    this.confirmBlockUnblock(item, true);
  }
  unblock(item) {
    this.confirmBlockUnblock(item, false);
  }

  confirmBlockUnblock(item, block) {
    let acao = (ok, justification) => {
      let parm = new BloqueioDesbloqueioParmDTO();
      parm.codigos = item.codigos;
      parm.ids = item.ids;
      parm.idUnidade = item.idUnidade;
      parm.justificativa = justification;

      let obs: Observable<any> = null;
      this.loader.start('Processando ...');
      if (block) {
        obs = service.blockDeliveryAddress(parm);
      } else {
        obs = service.unblockDeliveryAddress(parm);
      }
      obs.subscribe(
        (res) => {
          this.toast.show(res, 'success');
          this.pesquisar();
          this.loader.stop();
        },
        (error) => {
          this.showToastApiError(error);
          this.loader.stop();
        }
      );
    };

    this.dialog.show(
      'alert',
      item.nomeUnidade + ' - ' + (block ? 'Bloqueio de endereço' : 'Desbloqueio de endereço'),
      null,
      block ? 'Bloquear' : 'Desbloquear',
      acao,
      'Voltar',
      null,
      'Confirme o ' +
        (block ? 'bloqueio' : 'desbloqueio') +
        ' do endereco abaixo:<br><strong>' +
        item.endereco +
        '</strong> <br>',
      '450px',
      block ? 'orange white--text' : 'green white--text',
      'red white--text',
      true,
      true,
      'Justificativa',
      'Informe o motivo ...'
    );
  }
}
